import { useQuery } from '@tanstack/react-query';
import { queries } from '@/data';
import { useChoroplethStore } from './store';
import { LAYERS_BY_ID } from './layers-config';
import { blendHex } from './colors';

const GRADIENT_STEPS = 100;

// Inline legend — рендерится внутри LayerSwitcher (без своего абсолютного позиционирования).
// Раньше был отдельным элементом в углу карты — переехал в карточку слоя.
export function Legend() {
  const { activeLayer } = useChoroplethStore();
  const layerDef = LAYERS_BY_ID[activeLayer];
  const { data: meta } = useQuery(queries.meta());

  if (!layerDef || !meta) return null;

  const { stops, palette, unit, inverse } = layerDef;
  const minVal = stops[0];
  const maxVal = stops[stops.length - 1];

  // Build CSS gradient from palette stops
  const maxIdx = palette.length - 1;
  const gradientColors = Array.from({ length: GRADIENT_STEPS }, (_, i) => {
    const t = i / (GRADIENT_STEPS - 1);
    const value = minVal + t * (maxVal - minVal);
    for (let s = 0; s < stops.length - 1; s++) {
      if (value >= stops[s] && value <= stops[s + 1]) {
        const localT = (value - stops[s]) / (stops[s + 1] - stops[s]);
        // Clamp на случай если stops длиннее palette
        const a = palette[Math.min(s, maxIdx)];
        const b = palette[Math.min(s + 1, maxIdx)];
        return blendHex(a, b, localT);
      }
    }
    return palette[maxIdx];
  });

  const gradient = inverse
    ? [...gradientColors].reverse().join(', ')
    : gradientColors.join(', ');

  const displayMin = inverse ? maxVal : minVal;
  const displayMax = inverse ? minVal : maxVal;

  return (
    <div>
      <div
        className="h-2 w-full rounded-sm"
        style={{ background: `linear-gradient(to right, ${gradient})` }}
      />
      <div className="mt-1 flex justify-between text-[10px] text-slate-500">
        <span>
          {displayMin} {unit}
        </span>
        <span>
          {displayMax} {unit}
        </span>
      </div>
    </div>
  );
}
